import { QueryClient } from '@tanstack/react-query';
import { logger } from '@/utils/structuredLogging';

/**
 * Shared React Query client for the app.
 * Extracted so tests and edge-case bootstraps can import the same config.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      retry: (failureCount, error: any) => {
        // A restored mobile session can briefly return 401 while Supabase
        // refreshes its persisted token. Retry that race, but not other 4xx.
        if (error?.status === 401) return failureCount < 2;
        if (error?.status >= 400 && error?.status < 500) return false;
        if (error?.message?.includes('Failed to fetch')) return failureCount < 2;
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
      refetchOnReconnect: 'always',
      refetchOnMount: false,
      networkMode: 'offlineFirst',
    },
    mutations: {
      retry: false,
      onError: (error: any) => {
        logger.error('Mutation error', {
          component: 'QueryClient',
          action: 'mutation',
          metadata: { error: error?.message, code: error?.code },
        });
      },
    },
  },
});